// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2un-N","item":"PaymentsMobile_item__2ZLpv","label":"PaymentsMobile_label__2HegJ","amount":"PaymentsMobile_amount__1fuVz"};